module.exports = __webpack_public_path__ + "static/media/T5.db5d1a5c.jpg";